import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Drawer, Spin, Table } from 'antd'
import HandoverImageModal from './HandoverImageModal'
import { IMAGE_RETENTION_DAYS, formatDateTime, getSourceLabel } from '../../helpers/history'

const _formatReceiver = (receiver) => {
    const { name, phone } = receiver || {}
    return [name, phone].filter(Boolean).join(' · ') || '—'
}

const HandoverDetailDrawer = ({ visible, loading, detail, onClose, onPrint }) => {
    const [previewIndex, setPreviewIndex] = useState(-1)
    const batches = (detail && detail.batches) || []
    const partnerName = (detail && detail.partner_snapshot && detail.partner_snapshot.name) || ''

    const _onClose = () => {
        setPreviewIndex(-1)
        onClose()
    }

    const columns = [
        {
            title: '#',
            key: 'index',
            width: 48,
            render: (_, __, index) => index + 1,
        },
        {
            title: 'Ảnh lệnh may',
            key: 'image',
            width: 120,
            render: (_, batch, index) => {
                if (batch.image_expired) return <span className='ImageExpired'>Ảnh đã hết hạn lưu</span>
                if (!batch.image_url) return <span className='TextMuted'>Không có ảnh</span>

                return (
                    <button type='button' className='HandoverThumb' onClick={() => setPreviewIndex(index)}>
                        <img src={batch.image_url} alt={`Lệnh may lô ${batch.name}`} loading='lazy' />
                    </button>
                )
            },
        },
        {
            title: 'Tên lô',
            dataIndex: 'name',
            key: 'name',
            render: name => <b className='Mono'>{name}</b>,
        },
        {
            title: 'Nguồn',
            key: 'source',
            render: (_, batch) => getSourceLabel(batch),
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            key: 'sku',
            render: sku => <span className='Mono'>{sku || '—'}</span>,
        },
        {
            title: 'SL',
            dataIndex: 'quantity',
            key: 'quantity',
            align: 'right',
        },
    ]

    const title = (
        <div className='HandoverDetailDrawer__header'>
            <span>Lần giao {detail ? detail.code : ''}</span>
            <span className='HandoverDetailDrawer__headerActions'>
                <Button type='primary' disabled={!detail} onClick={() => onPrint(detail._id)}>In phiếu xuất kho</Button>
                <Button onClick={_onClose}>Đóng</Button>
            </span>
        </div>
    )

    return (
        <Drawer
            className='HandoverDetailDrawer'
            title={title}
            width='100%'
            closable={false}
            visible={visible}
            onClose={_onClose}
            destroyOnClose
        >
            <Spin spinning={loading}>
                {detail && (
                    <>
                        <div className='HandoverInfoGrid'>
                            <div><span>Đối tác may</span><b>{partnerName || '—'}</b></div>
                            <div><span>Thời gian giao</span><b>{formatDateTime(detail.handed_at)}</b></div>
                            <div><span>Người giao</span><b>{(detail.handed_by && detail.handed_by.username) || '—'}</b></div>
                            <div><span>Số lô / Tổng SL</span><b>{detail.total_batches} lô · {detail.total_quantity} item</b></div>
                            <div><span>Người nhận (lúc giao)</span><b>{_formatReceiver(detail.receiver)}</b></div>
                            <div><span>Lần in</span><b>{detail.print_count || 0}</b></div>
                        </div>

                        <Table
                            rowKey={batch => batch.id || batch.name}
                            size='middle'
                            columns={columns}
                            dataSource={batches}
                            pagination={false}
                        />

                        <div className='HandoverDetailDrawer__help'>
                            Bấm ảnh để xem lớn. Ảnh lưu {IMAGE_RETENTION_DAYS} ngày, sau đó hiện "Ảnh đã hết hạn lưu".
                        </div>
                    </>
                )}
            </Spin>

            {detail && (
                <HandoverImageModal
                    batches={batches}
                    index={previewIndex}
                    subtitle={`${detail.code} · ${partnerName}`}
                    onIndexChange={setPreviewIndex}
                    onClose={() => setPreviewIndex(-1)}
                />
            )}
        </Drawer>
    )
}

HandoverDetailDrawer.propTypes = {
    visible: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    detail: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
}

export default HandoverDetailDrawer
